export default "__VITE_ASSET__J9D6zWDt__"